import { CanMatchFn, Router } from '@angular/router';
import { userSelectors } from '@store/selectors/user.selectors';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { appSelectors } from '@store/selectors/app.selectors';
import { combineLatest, debounceTime, take } from 'rxjs';
import { masterSelectors } from '@store/selectors/master.selectors';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';

export const userIsAdminGuard: CanMatchFn = () => {
  const router = inject(Router);
  const store = inject(Store<StoreState>);
  const floatingAlertService = inject(FloatingAlertsService);
  const check$ = combineLatest([store.select(appSelectors.generalLoading), store.select(userSelectors.webIsReady)]).pipe(
    debounceTime(100),
    filter(([isLoading, webIsReady]) => !isLoading && webIsReady)
  );
  return check$.pipe(
    withLatestFrom(store.select(userSelectors.isSuperUser), store.select(masterSelectors.isAdmin)),
    take(1),
    map(([, isSuperUser, isAdmin]) => {
      if (isSuperUser || isAdmin) {
        return true;
      }
      floatingAlertService.error('ROUTES.ACCESS_NOT_ALLOWED');
      return router.createUrlTree(AcRoutingService.HOME_ROUTE());
    })
  );
};
